export default __webpack_public_path__ + "static/media/6.476ae651.png";